<template>
    <div v-if="isError" class="error-message">{{ errorMessage }}</div>
  </template>
  
  <script>
  export default {
    name: "ErrorMessage",
    props: {
      isError: {
        type: Boolean,
        required: true,
      },
      errorMessage: {
        type: String,
        required: true,
      },
    },
  };
  </script>
  
  <style scoped>
  .error-message {
    color: #DC3545; 
    font-size: 14px;
    margin-top: 16px;
    margin-bottom: 16px;
    position: absolute;    
  }
  </style>
  